<template>
  <div class="banner">
    <span class="title">
      <span class="text"
        ><strong>Nomad+</strong>, L'abonnement premium pour cartonner !</span
      >
      <span class="smiley">🎯</span>
    </span>
    <span class="subtitle">
      💯 Déjà 5 millions de jeunes accompagnés sur web et mobile.
    </span>
    <ButtonBase size="small" theme="secondary" rounded :to="urlPremium">{{
      buttonWording
    }}</ButtonBase>
  </div>
</template>
<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
const urlPremium = computed(() => `${runtimeConfig.public.eva1Url}/premium`);
const profile = useProfileStore();
const buttonWording = computed(() => {
  return profile.isASubscriber ? 'En savoir plus' : "S'abonner";
});
</script>
<style lang="scss" scoped>
.banner {
  display: flex;
  z-index: 2;
  top: 7.8rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 0.6rem;
  background-color: var(--color_secondary_darker);

  @include stroke('0', 'm');
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color_neutral_50);
    text-align: center;
    gap: 0.4rem;

    strong {
      color: var(--color_primary);
    }

    @include font('m', 800, 'secondary');
    @include above('l') {
      @include font('l', 800, 'secondary');
    }
    @include above('xl') {
      @include font('xxl', 800, 'secondary');
    }
  }
  .subtitle {
    display: none;
    color: var(--color_neutral_50);
    text-align: center;
    @include above('l') {
      display: block;
      margin-bottom: 0.5rem;
    }
    @include font('s', 600);
    @include above('xl') {
      margin-bottom: 0.8rem;
      @include font('n', 600);
    }
  }
  .smiley {
    display: none;
    margin-top: -0.8rem;
    font-size: 4rem;
    line-height: 3rem;
  }
}
</style>
